import React from 'react';
import { ShoppingCart } from 'lucide-react';
export function ViewCart() {
  return <div className="space-y-4" data-id="element-2439" data-mp="3fikd77ka6fre">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2440" data-mp="3fhshzxulik1n">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2441" data-mp="3kbn5zdh8hl6j">
          Shopping Cart
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2442" data-mp="3pahmu9vn4zo0">
          Review items in your cart before checkout.
        </p>
      </div>
      <p className="text-sm text-slate-600" data-id="element-2443" data-mp="2wjpzm1wjzlct">Your cart is now empty</p>
    </div>;
}